import { render, staticRenderFns } from "./PersonalForm.vue?vue&type=template&id=3a2aa42c&scoped=true&"
import script from "./PersonalForm.vue?vue&type=script&lang=js&"
export * from "./PersonalForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonalForm.vue?vue&type=style&index=0&id=3a2aa42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2aa42c",
  null
  
)

export default component.exports